<template>
  <div>
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'" :share="true"></lxm-nav>-->
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmItem from '../common/LxmItem.vue'
  export default {
    components: {
      LxmNav,
      LxmItem
    },
    computed: {
      transitionName () {
        return this.$store.getters.transitionName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?529c8446